<template>
<div>
  <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
	<div class="w-main m-auto">
		
		<div class="fr">
			
			
			<div class="hover-ucenter fl">
				<div class="top_ucenter fl fs-12 line-h40">
				
					
				</div>
			</div>

			
			
		<a class="fs-12 ftc-000000 line-h40 go-login more" href="/show" v-if="nickname!=null">
				<i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，{{nickname}}
			</a>
			<a class="fs-12 ftc-000000 line-h40 go-login more" href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect" v-if="nickname==null">
				<i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，请登录
			</a>
			<a href="/login" v-if="nickname!=null" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
			<a href="/login" v-if="nickname==null" class="fs-12 ftc-000000 line-h40 m-l-4 more"></a>
			<span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>
			
			<div class="fr m-l-15">
				<div class="my-lesson" >
					<a v-if="nickname!=null" href="/cglist" class="fl fs-12 ftc-000000 line-h40"><i class="iconfont icon-play1 m-r-4" ></i>作品列表</a>
					<a v-if="nickname==null" href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect" class="fl fs-12 ftc-000000 line-h40"><i class="iconfont icon-play1 m-r-4" ></i>作品列表</a>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="clear"></div>

<div class="toppic wall mb30">
	<div class="picself wall">
		<ul>
			<li><a href="/Show" >首页</a></li>
			<li><a href="/cgzp" >课改成果展评</a></li>
			<li><a href="/lwzp" >原创成果展评</a></li>
			<li>
            <a href="/lwList">上传作品</a>
          </li>
			<li><a href="/hjcx" >获奖查询</a></li>
		</ul>

		<!-- <a class="uploadfile"  href="/bmcs">上传作品</a> -->
		
	</div>
</div>
<div class="select">
	<div class="select_1">
		<el-input  placeholder="请输入姓名" prefix-icon="el-icon-edit" v-model="username" class="select_input"/><span style="width:20px"></span>
		<!-- <el-select v-model="type" placeholder="请选择" >
			<el-option label="论文展" value="论文">论文展</el-option>
			<el-option label="成果展" value="成果">成果展</el-option>
		</el-select><span style="width:20px"></span> -->
		<el-button type="primary" icon="el-icon-search" class="select_button" @click="select">查询</el-button>
	</div><br>
	<div class="bg" v-show="show">
		<ul>
			<li class="li_top">
				<label  class="fleft n8">作者姓名</label>
				<label  class="fleft n8">所获奖项</label>
				<label  class="fleft n30">获奖作品</label>
				<label  class="fleft n8">作品类型</label>
				<label  class="fleft n30">学校</label>
				<label  class="fleft n8">届数</label>
			
			</li>
			<li class="li_top" v-for="item in userinfo">
				<label  class="fleft n8">{{item.name}}</label>
				<label  class="fleft n8">{{item.prize}}</label>
				<label  class="fleft n30">{{item.worksname}}</label>
				<label  class="fleft n8" v-if="item.type == '成果'">{{item.workstype}}（课改成果展评）</label>
				<label  class="fleft n8" v-else>{{item.workstype}}</label>
				<label  class="fleft n30">{{item.school}}</label>
				<label  class="fleft n8" v-if="item.jieshu == 1">第一届</label>
				<label  class="fleft n8" v-if="item.jieshu == 2">第二届</label>
				<label  class="fleft n8" v-if="item.jieshu == 3">第三届</label>
				<label  class="fleft n8" v-if="item.jieshu == 4">第四届</label>
				<label  class="fleft n8" v-if="item.jieshu == 5">第五届</label>
			</li>
		</ul>
	</div>
</div>
<div class="main w1200 " style="margin-top:20px;margin-bottom: 40px;">
	
	<div class=" w1200  ">
	
		<div class="fl bghj ">
			<div style="position:absolute"><img src="../assets/images/cg.png" class="title_fudong" ></div>
			<div class="f14  of mt20" style="padding:30px 30px;">
			<p  class="f14  of" >
				1.本次课改课改成果展评按类分组（论文、专著、课题、公开课），各组分设特等奖、一等奖、二等奖和优秀奖四个奖次。<br/>
				2.获奖者均颁发加盖中国语文报刊协会、语文报社、语文报社基础教育研究院、《语文教学通讯·学术刊》公章的特制荣誉证书。获奖者将有机会受邀参加“语文报杯”全国中青年教师课堂教学大赛学术论坛，并被聘为语文报社基础教育研究院讲席专家。<br/>
				3.届时，中国知网也将展示和收录部分优秀获奖成果。<br/>
				4.特别优秀的获奖者，还将作为《语文教学通讯·学术刊》封面人物予以专栏介绍。<br/></p>
			</div>
			<div class='mb30' style="width:400px;margin:0 auto;"><a href="#" hover="hand"><img id="zs_luyong"   src="../assets/images/cg_zs.jpg" ></a></div>
			<p style="width:400px;margin:0 auto;">证书以实物为准</p>
		</div>
		<div class="fr bghj ">
			<div style="position:absolute"><img src="../assets/images/lw.png" class="title_fudong" ></div>
			<div class="f14  of mt20" style="padding:30px 30px;">
			<p  class="f14  of" >
				1.本项活动分原创论文与教学设计两组，各组分设特等奖、一等奖、二等奖、优秀奖四个奖次。<br/>
				2.获奖者均可获得加盖中国语文报刊协会、语文报社、语文报社基础教育研究院、《语文教学通讯·学术刊》公章的证书。获奖者将有机会受邀参加“语文报杯”全国中青年教师课堂教学大赛学术论坛，并被聘为语文报社基础教育研究院研究员。<br/>
				3.优秀作品将被中国知网《中国重要会议论文全文数据库（CPCD）》收录，具有与纸质刊物发表的同等效力，并为作者颁发收录证书，享受版权保护。 <br/><br/></p>
			</div>
			<div class='mb30' style="width:400px;margin:0 auto;"><a href="#" hover="hand"><img id="zs_luyong"   src="../assets/images/zs_luyong.png" ></a></div>
			<p style="width:400px;margin:0 auto;">证书以实物为准</p>
		</div>
		
	</div>
</div>
<div class="footer" style="background:url(('../../assets/images/foot.png')) top center no-repeat;">
  <div class="menu" >
    <div class="box">
    	<a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
    	<a href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html" target="_blank">联系我们</a>&nbsp;|&nbsp;
    	<a href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html" target="_blank">版权声明</a>
    	
  </div>

 <div class="copyright">
    <p>语文网版权所有 未经书面授权 不得复制或建立镜像  晋公网安备14010902000073号</p>
    <p>增值电信业务经营许可证晋B2-20030007  新出网许（晋）字005号  <a href="http://beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank">晋ICP备09011058号</a> <a href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn" name="f7c1c8d71288f01cb16d63638e8f82bc" >网站安全检测平台</a> </p>
  </div>

<a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn"><img border="0" src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85" style="display: none;"/></a>
</div>
</div>


</div>

</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
 export default {
    
    data() {
      return {
		  userinfo:[],
		  nickname : null,
		  username:null,
		  show:false,
		  
      }
    },
       created() {
    this.nickname = sessionStorage.getItem("nickname");
  		},
    mounted: function () {
    
    },
    methods: {
		 _isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
		toChengGuo:function(){
		console.log("this.nickname:",this.nickname)
		if(this.nickname!=null){
			this.$router.push({ path:'/cgList'  })
		} else {
			this.$router.push({ path:'https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'  })
		}
         
	  },
	  select:function(){
		  var that = this;
		  var name = this.username 
		  var type = this.type 
		  if(name==null || name==""){
			  alert("请输入姓名")
		  } else {
			 //上线前记得吧vue.config中的target修改了 还有后台的WebMvcConfig修改了
			   that.$axios.get("https://xspxserver.zhyww.cn/xspxPrize/getPrize",//http://localhost:8080/xspxPrize/getPrize     http://xspxserver.zhyww.cn/xspxPrize/getPrize
                {params:{
				name:name,
                }})
              .then(function (response) {
				  console.log( response.data.xspxPrizes)
				  var state = response.data.state
				  if(state == "1"){
  					that.userinfo = response.data.xspxPrizes
				    that.show = true
				  } else {
					  alert("没有查到获奖信息")
				  }
				  
				
              }).catch(function (reason) {
                  alert("error");
              });
			
		  }
	  }
	},
	
	 mounted: function() {
    if (this._isMobile()) {
 
    
      this.$router.replace('/hjcxPhone');
    }else {
      //alert('pc端');
      //this.$router.replace('/hjcx');
    }
  },
    
  }
</script>
<style>
 .select{
	padding: 25px 0 0;
   width: 1200px;
    overflow: hidden;
	background-color: #fff;
	margin: 50px auto 50px auto;

 }
 .select_1{
	 text-align: center;
	 display: flex;
	 width: 30%;
	 margin: 0 auto;
 }
 .li_top{
	 margin-top: 30px;
 }
</style>